module.exports = __webpack_public_path__ + "img/clockwise.a0f85d92.svg";